__turbopack_context__.v({
  "paddingForShadowDiv": "pTLayq_paddingForShadowDiv",
});
